import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

/**
 * 添加修改口径
 * @param approach
 */
export function insertApproach(approach) {
  return request({
    url: cmsServerContext + '/Approach/insertApproach',
    method: 'post',
    data: approach
  })
}

/**
 * 查询口径
 * @param customerId
 */
export function list(customerId) {
  return request({
    url: cmsServerContext + '/Approach/list/' + customerId,
    method: 'get'
  })
}
/**
 * 查询口径
 * @param customerId type
 */
export function getApproach(customerId,type) {
  return request({
    url: cmsServerContext + '/Approach/getApproach/',
    method: 'post',
    data:{customerId:customerId,type:type}
  })
}
/**
 * 根据id查询口径
 * @param approachId
 */
export function selectApproachById(approachId) {
  return request({
    url: cmsServerContext + '/Approach/selectApproachById/' + approachId,
    method: 'get'
  })
}
/**
 * 根据id查询口径
 * @param approachId
 */
export function deleteApproach(approachId) {
  return request({
    url: cmsServerContext + '/Approach/deleteApproach/' + approachId,
    method: 'delete'
  })
}